import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ApiResponse } from 'src/app/models/IApiResponse';
import { Observable, catchError } from 'rxjs';
import { ConfigErrorHandler } from 'src/app/shared/config.errorhandler';

@Injectable({
  providedIn: 'root'
})
export class UpdateVehicleSparePartsService {
  private baseURL = environment.apiURL;
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(
    private http: HttpClient,
    private errorHandler: ConfigErrorHandler
  ) { }

 /**
  * Get all spare parts
  * @returns Observable<ApiResponse>
  */
  getVehicleSpareParts(): Observable<ApiResponse>
  {
    let apiURL:string=`${this.baseURL}/v1/spare-parts`;

    return this.http.get<ApiResponse>(apiURL,{ headers: this.headers }).pipe(catchError(this.errorHandler.handleError));
  }

  /**
     * Update vehicle spare parts
     * @param chassisNo
     * @param selectedSpareParts
     * @returns
     */
    update(chassisNo: string, selectedSpareParts: any[]): Observable<any> {

      let apiURL:string=`${this.baseURL}/v1/update-spare-parts`;

      const data = {
        chassis_no:chassisNo,
        selected_spare_parts: selectedSpareParts
      };

      return this.http.post<any>(apiURL, data);
    }

}
